export class BlogContent {
    public id: number;
    public content: string;
    public header: string;
    public headerImage: string;
    public language: string;

    static fromDto(b): BlogContent {
        const blogContent = new BlogContent();

        if (!b) {
            return null;
        }

        blogContent.id = b.id;
        blogContent.content = b.content;
        blogContent.header = b.header;
        blogContent.headerImage = b.headerImage;
        blogContent.language = b.language;

        return blogContent;
    }
}
